import { useEffect } from 'react';
export const META_PIXEL_ID = '1220154616882050';
let initialized = false;
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || initialized) return;
    initialized = true;
    try {
      const w = window as unknown as Record<string, any>;
      if (!w.fbq) {
        const fbq: any = function (...args: unknown[]) {
          if (fbq.callMethod) {
            fbq.callMethod.apply(fbq, args);
          } else {
            fbq.queue.push(args);
          }
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        w.fbq = fbq;
        w._fbq = fbq;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch {
      /* tracking must never break the page */
    }
  }, []);
  return null;
}